import { render, staticRenderFns } from "./SVGEditorMessages.vue?vue&type=template&id=47fd8c74&scoped=true"
import script from "./SVGEditorMessages.vue?vue&type=script&lang=js"
export * from "./SVGEditorMessages.vue?vue&type=script&lang=js"
import style0 from "./SVGEditorMessages.vue?vue&type=style&index=0&id=47fd8c74&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fd8c74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47fd8c74')) {
      api.createRecord('47fd8c74', component.options)
    } else {
      api.reload('47fd8c74', component.options)
    }
    module.hot.accept("./SVGEditorMessages.vue?vue&type=template&id=47fd8c74&scoped=true", function () {
      api.rerender('47fd8c74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/SVGEditorMessages.vue"
export default component.exports